'use client';

/**
 * TalkCta — 카톡방 1(§1-6). 하단의 차분한 아웃라인 버튼. 계측은 기존 talk-banner(user_events) 슬롯 'site_cta'.
 * SSR 마크업은 정적 <a href> — JS 없이도 동작한다.
 */
import { useEffect, useRef } from 'react';
import { KAKAO_TALK_URL, talkSiteLabel, trackTalkClick, trackTalkView } from '@/lib/talk-banner';
import { TalkLiveLabel } from '@/components/live/LiveBadge';
import './cl.css';

export interface TalkCtaProps {
  siteSlug?: string | null;
  /** retention-1031 — 현장 이름이 있으면 문구가 「{현장명} 소식 카톡방에서 받기」(label 을 주면 label 이 이긴다). 계측 props.copy='site'. */
  siteName?: string | null;
  label?: string;
  /** nav-live(2026-10-24) — true 면 「LIVE」 표지(빨간 맥박 점)를 문구 앞에 붙인다(상세 하단 바 「실시간 소통」). 링크·계측 불변. */
  live?: boolean;
}

export default function TalkCta({ siteSlug, siteName, label, live = false }: TalkCtaProps) {
  const ref = useRef<HTMLAnchorElement>(null);
  const text = label ?? talkSiteLabel(siteName);
  const copy = !label && siteName ? 'site' : 'generic';
  const props = siteSlug ? { site_slug: siteSlug, surface: 'cl', copy } : { surface: 'cl', copy };
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver((es) => {
      if (es.some((e) => e.isIntersecting)) {
        trackTalkView('site_cta', props);
        io.disconnect();
      }
    }, { threshold: 0.5 });
    io.observe(el);
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteSlug]);
  return (
    <a
      ref={ref}
      className={live ? 'cl-talk kd-lv-host' : 'cl-talk'}
      href={`${KAKAO_TALK_URL}?utm_source=cl_detail`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackTalkClick('site_cta', props)}
      data-cl-cta="talk"
      {...(live ? { 'data-live': '' } : {})}
    >
      {live ? <TalkLiveLabel label={text} /> : text}
    </a>
  );
}
